export default "__VITE_ASSET__BIXnrirM__"